import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import Form from "./Form";

const { Flex, Heading, ModalCloseButton } = Chakra;

const RegistrationForm = () => {
  const translations = useTranslations();
  return (
    <Flex p={10} flexDir="column">
      <Flex pb={6} align="center" justify="space-between">
        <Heading variant="h3" as="h3">
          {translations("form_become_a_partner")}
        </Heading>
        <ModalCloseButton size="md" color="primary.900" />
      </Flex>
      <Form />
    </Flex>
  );
};

export default RegistrationForm;
